import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Candidate from "./pages/technology/Candidate";
import Home from "./pages/Home";
import About from "./pages/About";
import Publications from "./pages/Publications";
import Contact from "./pages/Contact";
import LeadIndications from "./pages/technology/LeadIndications";
import STARS from "./pages/trials/STARS";
import CoSTARS from "./pages/trials/CoSTARS";
import Media from "./pages/Media";
import NatureArticle from "./pages/media/nature";
import ABCNews from "./pages/media/abc";
import JPMorganArticle from "./pages/media/jpmorgan";
import BoardOfDirectors from "./pages/leadership/BoardOfDirectors";
import SeniorManagement from "./pages/leadership/SeniorManagement";
import CorporateAdvisors from "./pages/leadership/CorporateAdvisors";
import NotFound from "./pages/404";
import ScrollToTop from "./components/ScrollToTop";

export default function App() {
  // Create a helmet context
  const helmetContext = {};

  return (
    <HelmetProvider context={helmetContext}>
      <div className="min-h-dvh flex flex-col">
        <Header />
        <div className="flex-grow relative">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/leadership/board-of-directors" element={<BoardOfDirectors />} />
            <Route path="/leadership/senior-management" element={<SeniorManagement />} />
            <Route path="/leadership/corporate-advisors" element={<CorporateAdvisors />} />
            <Route path="/media" element={<Media />} />
            <Route path="/media/nature" element={<NatureArticle />} />
            <Route path="/media/abc" element={<ABCNews />} />
            <Route path="/media/jpmorgan" element={<JPMorganArticle />} />
            <Route path="/trials/stars" element={<STARS />} />
            <Route path="/trials/costars" element={<CoSTARS />} />
            <Route path="/publications/*" element={<Publications />} />
            <Route path="/technology/candidate" element={<Candidate />} />
            <Route path="/technology/leadIndication" element={<LeadIndications />} />
            {/* 404 page - catches all unmatched routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}